import type { DeepReadonly, Ref } from 'vue'
import { ref, readonly } from 'vue'

interface ImageEditorElement {
  zoom(zoomFactor: number): void
  rotate(degree: number): void
}

export interface UseImageEditor {
  editorElement: DeepReadonly<Ref<ImageEditorElement | null>>
  zoomIn(zoomFactor?: number): void
  rotateLeft(degree?: number): void
  zoomOut(zoomFactor?: number): void
  rotateRight(degree?: number): void
  fillArea(imageData: { imageSize: { width: number; height: number } }): { width: number; height: number }
}

export function useImageEditor(): UseImageEditor {
  const editorElement = ref<ImageEditorElement | null>(null)

  function zoomIn() {
    editorElement.value?.zoom(2)
  }

  function zoomOut() {
    editorElement.value?.zoom(0.5)
  }

  function rotateLeft() {
    editorElement.value?.rotate(90)
  }

  function rotateRight() {
    editorElement.value?.rotate(-90)
  }

  function fillArea({ imageSize }: { imageSize: { width: number; height: number } }) {
    return {
      width: imageSize.width,
      height: imageSize.height,
    }
  }

  return {
    editorElement: readonly(editorElement),
    zoomIn,
    zoomOut,
    fillArea,
    rotateLeft,
    rotateRight,
  }
}
